import React, { Component } from 'react';
import {
  Row, Col, Form, Select, Input, Checkbox, Button, Radio,
} from 'antd';
import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_KEY } from 'env';
import autobind from 'react-autobind';
import PropTypes from 'prop-types';
import { formPropType } from 'utils/propType';
import { FormControl, FormRules, FormUtils } from 'form-control';
import InputMask from 'react-input-mask';
import translate from 'app/translations';
import { getTypesAsProps } from 'utils/typeUtils';
import { US_STATES, PROFILE_STEP_TYPES } from 'app/constants';
import AddressSearch from 'addresss-search/AddressSearch';
import AgentProfilePropType from '../AgentProfilePropType';
import WizardNav from './WizardNav';

const { Option } = Select;
const RadioGroup = Radio.Group;

const GENDER_OTHER = 'OTHER';
const ETHNICITY_OTHER = 'OTHER';
const DIVERSE_GROUP_OTHER = 'OTHER';
export const TAX_ID_TYPE_FIELD = 'taxIdType';
const SSN_TYPE = 'SSN';
const TIN_TYPE = 'TIN';

export class UserProfileComponent extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  onDiversityAffirmedChange(changeEvt) {
    if (!changeEvt.target.checked) {
      this.props.form.resetFields([
        'gender',
        'otherGender',
        'ethnicity',
        'otherEthnicity',
        'diverseGroup',
        'otherDiverseGroup',
      ]);
    }
  }

  onSubmit(nextPage) {
    const { form } = this.props;
    form.validateFieldsAndScroll((errors, values) => {
      if (!errors) {
        const payload = this.getPayload(values);
        const { isAuthenticated, userProfile } = this.props.agentProfile;
        const shouldClearCoverage = this.shouldClearCoverageZips(isAuthenticated, values.state, userProfile.state);

        if (shouldClearCoverage) this.clearCoverageZips();
        this.props.onSaveUserProfileRequest(nextPage, isAuthenticated, payload, shouldClearCoverage);
      }
    });
  }

  getSSNOrTIN(values) {
    if (values.ssn) {
      return values.ssn;
    }
    return values.tin;
  }

  getFieldFromFormOrState(fieldname) {
    let fieldValue = this.props.form.getFieldValue(fieldname);
    if (typeof fieldValue === 'undefined') {
      const { userProfile } = this.props.agentProfile;
      fieldValue = userProfile[fieldname];
      return fieldValue;
    }
    return fieldValue;
  }

  getPayload(values) {
    const payload = {
      ...values,
      ssn: this.getSSNOrTIN(values),
      gender: values.gender || '',
      otherGender: values.otherGender || '',
      ethnicity: values.ethnicity || '',
      otherEthnicity: values.otherEthnicity || '',
      diverseGroup: values.diverseGroup || '',
      otherDiverseGroup: values.otherDiverseGroup || '',
    };

    // TIN gets saved as SIN, this would be a duplicate
    delete payload.tin;
    return payload;
  }

  clearCoverageZips() {
    const { regionCoverage } = this.props.agentProfile;
    const payload = {
      ...regionCoverage,
      mlsCoverage: false,
      zipCodes: [],
    };

    this.props.onSaveRegionCoverageRequest(null, payload);
  }

  shouldClearCoverageZips(isAuthenticated, formZip, appStateZip) {
    return (isAuthenticated && formZip && appStateZip && formZip !== appStateZip);
  }

  handleSearchAddressSelect(address) {
    const { form } = this.props;
    form.resetFields([
      'addressLine1',
      'addressLine2',
      'city',
      'state',
      'zipCode',
    ]);
    this.props.form.setFieldsValue({
      addressLine1: address.street1 || undefined,
      addressLine2: address.street2 || undefined,
      city: address.city || undefined,
      state: address.state || undefined,
      zipCode: address.zip || undefined,
    });
  }

  isSSN() {
    const { TAX_ID } = this.props.agentProfile.constants;
    if (TAX_ID === undefined || TAX_ID.length === 0) return true;
    const taxIdTypes = getTypesAsProps(TAX_ID);
    const taxIdType = this.getFieldFromFormOrState(TAX_ID_TYPE_FIELD);

    if (taxIdTypes.SSN === undefined || taxIdType === taxIdTypes.SSN.value) {
      return true;
    }
    return false;
  }

  render() {
    const placeHolderChar = '\u2000';
    const isReadOnly = '';
    const {
      form,
    } = this.props;

    const {
      isAuthenticated,
      userProfile,
      isCallInprogress,
      constants,
    } = this.props.agentProfile;

    const {
      GENDER,
      ETHNICITY,
      DIVERSE_GROUP,
      TAX_ID,
    } = constants;

    const isSSN = this.isSSN();

    return (
      <div className="user-profile ">
        <Form layout="vertical">
          <div className="card-container responsive-border">
            <h2 className="orange-text">{this.t('UserProfile.profile')}</h2>
            <Row gutter={16}>
              <Col xs={24} md={8}>
                <FormControl
                  form={form}
                  fieldName="firstName"
                  displayName={this.t('UserProfile.firstName')}
                  initialValue={userProfile.firstName}
                  rules={[FormRules.REQUIRED]}
                  readOnly={isReadOnly}
                >
                  <Input
                    maxLength={40}
                    autoComplete="off"
                    placeholder={this.t('UserProfile.firstName')}
                  />
                </FormControl>
              </Col>
              <Col xs={24} md={8}>
                <FormControl
                  form={form}
                  fieldName="middleName"
                  displayName={this.t('UserProfile.middleName')}
                  initialValue={userProfile.middleName}
                >
                  <Input
                    maxLength={40}
                    autoComplete="off"
                    placeholder={this.t('UserProfile.middleName')}
                  />
                </FormControl>
              </Col>
              <Col xs={24} md={8}>
                <FormControl
                  form={form}
                  fieldName="lastName"
                  displayName={this.t('UserProfile.lastName')}
                  initialValue={userProfile.lastName}
                  rules={[FormRules.REQUIRED]}
                  readOnly={isReadOnly}
                >
                  <Input
                    maxLength={40}
                    autoComplete="off"
                    placeholder={this.t('UserProfile.lastName')}
                  />
                </FormControl>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col lg={12} md={12} sm={12} xs={24}>
                <FormControl
                  form={form}
                  fieldName={TAX_ID_TYPE_FIELD}
                  displayName={this.t('UserProfile.taxId')}
                  initialValue={userProfile.taxIdType || SSN_TYPE}
                  rules={[FormRules.REQUIRED]}
                  readOnly={isReadOnly}
                >
                  <RadioGroup
                    className="correct-align-radio-buttons"
                    options={TAX_ID.map(taxIdType => ({ label: taxIdType.name, value: taxIdType.value }))}
                  />
                </FormControl>

              </Col>

              { !isSSN && (
                <Col md={7} sm={12} xs={24}>
                  <FormControl
                    form={form}
                    fieldName="tin"
                    displayName={this.t('UserProfile.tin')}
                    initialValue={userProfile.taxIdType === TIN_TYPE ? userProfile.ssn : ''}
                    rules={[FormRules.REQUIRED, { [FormRules.LENGTH]: [10, 10] }]}
                    readOnly={isReadOnly}
                  >
                    <InputMask
                      className="ant-input"
                      mask="99-9999999"
                      maskChar=""
                      placeholder={this.t('UserProfile.tinPlaceholder')}
                    />
                  </FormControl>
                </Col>
              )}
              { isSSN && (
                <Col md={7} sm={12} xs={24}>
                  <FormControl
                    form={form}
                    fieldName="ssn"
                    displayName={this.t('UserProfile.ssn')}
                    readOnly={isReadOnly}
                    initialValue={userProfile.taxIdType === SSN_TYPE ? userProfile.ssn : ''}
                    rules={[FormRules.REQUIRED, { [FormRules.LENGTH]: [11, 11] }]}
                  >
                    <InputMask
                      className="ant-input"
                      mask="999-99-9999"
                      maskChar=""
                      placeholder={this.t('UserProfile.socialSecurityPlaceholder')}
                    />
                  </FormControl>
                </Col>
              )}
            </Row>
            <Row>
              <Col xs={24} md={11}>
                <FormControl
                  form={form}
                  fieldName="email"
                  autoComplete="off"
                  displayName={this.t('UserProfile.email')}
                  initialValue={userProfile.email}
                  rules={[FormRules.REQUIRED, { [FormRules.PATTERN]: FormUtils.regex.email }]}
                  readOnly={isReadOnly}
                >
                  <Input
                    type="email"
                    autoComplete="off"
                    maxLength={100}
                    placeholder={this.t('UserProfile.email')}
                    disabled={isAuthenticated}
                  />
                </FormControl>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={10}>
                <FormControl
                  form={form}
                  fieldName="mobile"
                  displayName={this.t('UserProfile.mobile')}
                  initialValue={userProfile.mobile}
                  rules={[FormRules.REQUIRED, { [FormRules.LENGTH]: [12, 10] }]}
                  readOnly={isReadOnly}
                >
                  <InputMask
                    className="ant-input"
                    mask="999\-999\-9999"
                    autoComplete="off"
                    maskChar={placeHolderChar}
                    placeholder={this.t('UserProfile.mobile')}
                  />
                </FormControl>
              </Col>
              <Col xs={24} md={10}>
                <FormControl
                  form={form}
                  fieldName="alternatePhone"
                  displayName={this.t('UserProfile.alternatePhone')}
                  initialValue={userProfile.alternatePhone}
                  rules={[{ [FormRules.LENGTH]: [12, 10] }]}
                  readOnly={isReadOnly}
                >
                  <InputMask
                    className="ant-input"
                    mask="999\-999\-9999"
                    autoComplete="off"
                    maskChar={placeHolderChar}
                    placeholder={this.t('UserProfile.alternatePhone')}
                  />
                </FormControl>
              </Col>
              <Col xs={24} md={4}>
                <FormControl
                  form={form}
                  fieldName="alternatePhoneExt"
                  displayName={this.t('UserProfile.alternatePhoneExt')}
                  initialValue={userProfile.alternatePhoneExt}
                  rules={[FormRules.POSITIVEINT]}
                  readOnly={isReadOnly}
                >
                  <InputMask
                    className="ant-input"
                    mask="9999999999"
                    autoComplete="off"
                    maskChar=""
                    placeholder={this.t('UserProfile.alternatePhoneExt')}
                  />
                </FormControl>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col lg={24} xl={10}>
                <h3>{this.t('UserProfile.address')}</h3>
                <div className="ant-row ant-form-item form-control">
                  <AddressSearch
                    onAddressSelected={this.handleSearchAddressSelect}
                  />
                </div>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col lg={24}>
                <FormControl
                  form={form}
                  fieldName="addressLine1"
                  displayName={this.t('UserProfile.addressLine1')}
                  initialValue={userProfile.addressLine1}
                  rules={[FormRules.REQUIRED]}
                  readOnly={isReadOnly}
                >
                  <Input
                    maxLength={45}
                    placeholder={this.t('UserProfile.addressLine1')}
                    autoComplete="off"
                  />
                </FormControl>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col lg={24}>
                <FormControl
                  form={form}
                  fieldName="addressLine2"
                  displayName={this.t('UserProfile.addressLine2')}
                  initialValue={userProfile.addressLine2}
                  readOnly={isReadOnly}
                >
                  <Input
                    maxLength={45}
                    autoComplete="off"
                    placeholder={this.t('UserProfile.addressLine2')}
                  />
                </FormControl>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="city"
                  displayName={this.t('UserProfile.city')}
                  initialValue={userProfile.city}
                  rules={[FormRules.REQUIRED]}
                  readOnly={isReadOnly}
                >
                  <Input
                    maxLength={50}
                    placeholder={this.t('UserProfile.city')}
                    autoComplete="off"
                  />
                </FormControl>
              </Col>
              <Col xs={24} md={5}>
                <FormControl
                  form={form}
                  fieldName="state"
                  displayName={this.t('UserProfile.state')}
                  initialValue={userProfile.state || undefined}
                  rules={[FormRules.REQUIRED]}
                  readOnly={isReadOnly}
                >
                  <Select
                    showSearch
                    autoComplete="off"
                    filterOption={(userInput, option) => FormUtils.filterOptions(userInput, option)}
                    placeholder={this.t('UserProfile.state')}
                  >
                    {
                      US_STATES.map(s => (<Option value={s.value} key={s.value}>{s.name}</Option>))
                    }
                  </Select>
                </FormControl>
              </Col>
              <Col lg={24} xl={7}>
                <FormControl
                  form={form}
                  fieldName="zipCode"
                  displayName={this.t('UserProfile.zipCode')}
                  initialValue={userProfile.zipCode}
                  rules={[FormRules.REQUIRED, { [FormRules.LENGTH]: [5, 5] }]}
                  readOnly={isReadOnly}
                >
                  <InputMask
                    className="ant-input"
                    autoComplete="off"
                    mask="99999"
                    maskChar=""
                    placeholder={this.t('UserProfile.zipCode')}
                  />
                </FormControl>
              </Col>
            </Row>
          </div>
          <div className="card-container responsive-border">
            <h2 className="orange-text">{this.t('UserProfile.diversityHeading')}</h2>
            <h3>{this.t('UserProfile.diversityAffirmation')}</h3>
            <Row gutter={16}>
              <Col xs={24}>
                <FormControl
                  form={form}
                  fieldName="isDiversityAffirmed"
                  displayName=" "
                  isCheckbox="checkbox"
                  initialValue={userProfile.isDiversityAffirmed}
                >
                  <Checkbox
                    autoComplete="off"
                    onChange={this.onDiversityAffirmedChange}
                  >
                    {this.t('UserProfile.diversityCheckLabel')}
                  </Checkbox>
                </FormControl>
              </Col>
            </Row>
            {this.getFieldFromFormOrState('isDiversityAffirmed') && (
              <div>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <FormControl
                      form={form}
                      fieldName="gender"
                      displayName={this.t('UserProfile.gender')}
                      initialValue={userProfile.gender || undefined}
                      rules={[FormRules.REQUIRED]}
                      readOnly={isReadOnly}
                    >
                      <Select
                        showSearch
                        autoComplete="off"
                        filterOption={(userInput, option) => FormUtils.filterOptions(userInput, option)}
                        placeholder={this.t('UserProfile.gender')}
                      >
                        {
                          GENDER.map(g => (<Option value={g.value} key={g.value}>{g.name}</Option>))
                        }
                      </Select>
                    </FormControl>
                  </Col>
                  {this.getFieldFromFormOrState('gender') === GENDER_OTHER && (
                    <Col xs={24} md={12}>
                      <FormControl
                        form={form}
                        fieldName="otherGender"
                        displayName={this.t('UserProfile.otherGender')}
                        initialValue={userProfile.otherGender}
                        rules={[FormRules.REQUIRED]}
                        readOnly={isReadOnly}
                      >
                        <Input
                          placeholder={this.t('UserProfile.otherGender')}
                          autoComplete="off"
                        />
                      </FormControl>
                    </Col>
                  )}
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <FormControl
                      form={form}
                      fieldName="ethnicity"
                      displayName={this.t('UserProfile.ethnicity')}
                      initialValue={userProfile.ethnicity || undefined}
                      rules={[FormRules.REQUIRED]}
                      readOnly={isReadOnly}
                    >
                      <Select
                        showSearch
                        autoComplete="off"
                        filterOption={(userInput, option) => FormUtils.filterOptions(userInput, option)}
                        placeholder={this.t('UserProfile.ethnicity')}
                      >
                        {
                          ETHNICITY.map(g => (<Option value={g.value} key={g.value}>{g.name}</Option>))
                        }
                      </Select>
                    </FormControl>
                  </Col>
                  {this.getFieldFromFormOrState('ethnicity') === ETHNICITY_OTHER && (
                    <Col xs={24} md={12}>
                      <FormControl
                        form={form}
                        fieldName="otherEthnicity"
                        displayName={this.t('UserProfile.otherEthnicity')}
                        initialValue={userProfile.otherEthnicity}
                        rules={[FormRules.REQUIRED]}
                        readOnly={isReadOnly}
                      >
                        <Input
                          autoComplete="off"
                          placeholder={this.t('UserProfile.otherEthnicity')}
                        />
                      </FormControl>
                    </Col>
                  )}
                </Row>

                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <FormControl
                      form={form}
                      fieldName="diverseGroup"
                      displayName={this.t('UserProfile.diverseGroup')}
                      initialValue={userProfile.diverseGroup || undefined}
                      rules={[FormRules.REQUIRED]}
                      readOnly={isReadOnly}
                    >
                      <Select
                        showSearch
                        autoComplete="off"
                        filterOption={(userInput, option) => FormUtils.filterOptions(userInput, option)}
                        placeholder={this.t('UserProfile.diverseGroup')}
                      >
                        {
                          DIVERSE_GROUP.map(g => (<Option value={g.value} key={g.value}>{g.name}</Option>))
                        }
                      </Select>
                    </FormControl>
                  </Col>
                  {this.getFieldFromFormOrState('diverseGroup') === DIVERSE_GROUP_OTHER && (
                    <Col xs={24} md={12}>
                      <FormControl
                        form={form}
                        fieldName="otherDiverseGroup"
                        displayName={this.t('UserProfile.otherDiverseGroup')}
                        initialValue={userProfile.otherDiverseGroup}
                        rules={[FormRules.REQUIRED]}
                        readOnly={isReadOnly}
                      >
                        <Input
                          placeholder={this.t('UserProfile.otherDiverseGroup')}
                          autoComplete="off"
                        />
                      </FormControl>
                    </Col>
                  )}
                </Row>
              </div>
            )}

            {!isAuthenticated && (
              <div>
                <Row gutter={16}>
                  <Col xs={24} md={12} style={{ paddingTop: 10 }}>
                    {!isCallInprogress && (
                      <Form.Item>
                        {form.getFieldDecorator('tc.recaptcha', {
                          rules: [{
                            required: true, message: this.t('UserProfile.completeRecaptcha'),
                          }],
                          initialValue: undefined,
                        })(<ReCAPTCHA
                          sitekey={RECAPTCHA_KEY}
                        />)}
                      </Form.Item>
                    )}
                  </Col>
                  <Col xs={24} md={12} className="align-right">
                    <Form.Item>
                      {form.getFieldDecorator('tc.isTermsAndConditionsAccepted', {
                        rules: [{
                          required: true,
                          message: this.t('UserProfile.t&c.required'),
                        }],
                      })(
                        <Checkbox>
                          {this.t('UserProfile.t&c.iAgree')}
                          <a href="./pdfs/termsOfUse.pdf" target="_blank">
                            {this.t('UserProfile.t&c.solidifiT&c')}
                          </a>
                          {this.t('UserProfile.t&c.and')}
                          <a href="./pdfs/privacyPolicy.pdf" target="_blank">
                            {this.t('UserProfile.t&c.privacyPolicy')}
                          </a>.
                        </Checkbox>,
                      )}
                    </Form.Item>
                    <Button
                      type="primary"
                      onClick={this.onSubmit}
                      disabled={isCallInprogress}
                    >
                      {this.t('UserProfile.callToAction')}
                    </Button>
                  </Col>
                </Row>
              </div>
            )}


          </div>

          {isAuthenticated && (
            <WizardNav
              agentProfile={this.props.agentProfile}
              isCallInProgress={isCallInprogress}
              currentPage={PROFILE_STEP_TYPES.USER_PROFILE}
              onNavigate={this.onSubmit}
            />
          )}
        </Form>
      </div>
    );
  }
}

UserProfileComponent.propTypes = {
  agentProfile: PropTypes.shape(AgentProfilePropType).isRequired,
  form: PropTypes.shape(formPropType).isRequired,
  onSaveUserProfileRequest: PropTypes.func.isRequired,
  onSaveRegionCoverageRequest: PropTypes.func,
};

UserProfileComponent.defaultProps = {
  onSaveRegionCoverageRequest: null,
};

export default Form.create()(UserProfileComponent);
